import { Component } from 'react';
import { withRouter } from 'react-router-dom';

// This is a helper component that helps to scroll the page to top when changing routes.
// This simulates regular web page behaviour

class ScrollToTop extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return null;
  }
}

export default withRouter(ScrollToTop);
